import styled from 'styled-components';
import {
  accentColorPrim,
  accentColorSecond,
  fontColorPrim,
  fontColorSecond,
  white,
} from '../../../../assets/styledAssets/vars';
import * as CSS from 'csstype';
import { Editor } from '@progress/kendo-react-editor';
import {AppBar, Tabs} from "@material-ui/core";

export const StyledA = styled.a`
  cursor: pointer;
  color: ${fontColorSecond};
  font-size: 1.6rem;
  text-decoration: none;
  &:hover,
  &:focus,
  &.active {
    color: ${accentColorPrim};
    text-decoration: none;
    text-shadow: 0px 0px 1px ${accentColorPrim};
  }
`;
export const StyledTransparentInputSM = styled.div<Partial<CSS.Properties>>`
  width: 100%;
  input {
    width: 100%;
    border: 0;
    box-shadow: none;
    background-color: transparent;
    min-height: 1.6rem;
    border-bottom: 1px solid transparent;
    font-size: 1.6rem;
    color: ${fontColorPrim};
    padding: 1.2rem 1.6rem;
    resize: vertical;
    &:focus,
    &:hover {
      box-shadow: none;
      outline: none;
      border-bottom: 1px solid ${accentColorSecond};
    }
  }
`;

interface StyledTransparentInputProps{
  fs: string,
  secondary: boolean
}

export const StyledTransparentInput = styled.div<
  Partial<CSS.Properties & StyledTransparentInputProps>>`
  width: 100%;
  input, textarea {
    width: 100%;
    border: 0;
    box-shadow: none;
    background-color: transparent;
    min-height: 4.8rem;
    border-bottom: 1px solid transparent;
    font-size: ${(props) => props.fs || '2.4rem'};
    font-weight: bold;
    color: ${(props)=>props.secondary ? fontColorSecond : fontColorPrim};
    padding: 1.2rem 1.6rem;
    resize: vertical;
    &:focus,
    &:hover {
      box-shadow: none;
      outline: none;
      border-bottom: 1px solid ${accentColorSecond};
    }
  }
`;

export const StyledTransparentTxtArea = styled.div<Partial<CSS.Properties>>`
  width: 100%;
  .k-textarea {
    border: 0;
    width: 100%;
    &:focus-within {
      box-shadow: none;
    }
  }
  textarea {
    width: 100%;
    border: 0;
    box-shadow: none;
    background-color: transparent;
    min-height: 4.8rem;
    font-size: 1.6rem;
    font-weight: bold;
    border: 0;
    border-bottom: 1px solid transparent;
    color: ${fontColorSecond};
    padding: 1.2rem 1.6rem;
    resize: none;
    &:focus,
    &:hover {
      box-shadow: none;
      outline: none;
      border-bottom: 1px solid ${accentColorSecond};
    }
  }
`;

export const StyledEditor = styled(Editor)`
  width:100%;
  border-radius:1rem;
  border:0;
  padding: 0 1rem;
  .k-toolbar{
    border-top-left-radius:1rem;
    border-top-right-radius:1rem;
    border-bottom:0;
    background-color:${white};
    background-image:none;
    .k-button{
      border:0;
      background-color:${white};
      background-image:none;
      .k-icon{color:${fontColorPrim}  
    }
  }
`;


export const EditorWrap = styled.div`
  position: relative;
  width: calc(100% - 6rem);
  padding: 1rem;
  margin-bottom: 3rem;
  background-color: ${white};
  border-radius: 1rem;
  border: 1px solid ${accentColorSecond};
  .editor-toolbar-controls {
    position: absolute;
    top: 2rem;
    right: 2rem;
    button {
      min-height: 0.3rem;
      min-width: 3rem;
      padding: 0.4rem;
    }
  }
  .editor-body {
    padding: 1rem;
  }
`;

export const StyledTabs = styled(Tabs)`
  background-color:transparent;
`

export const StyledAppBar = styled(AppBar)`
  &, &.MuiAppBar-colorPrimary{
    background-color:transparent;
    box-shadow: none;
    width: auto;
    .MuiTab-wrapper{
      color: ${fontColorSecond};
      font-weight: bold;
      font-family: -apple-system, 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      text-transform: capitalize;
      font-size: 1.4rem;
    }
    .Mui-selected .MuiTab-wrapper{
      color: ${accentColorPrim};
    }
    .MuiTabs-indicator{
      background-color: ${accentColorPrim};
    }
  }
`